import { Box } from '@mui/material'
import InputLabel from '@mui/material/InputLabel'
import TextField from '@mui/material/TextField'
import React, { ChangeEvent, FC } from 'react'
import { fontSize } from 'shared/style/constants'

interface ToggleEditTextFieldMultilineProps {
    edit: boolean
    disabled?: boolean
    label: string
    value: string
    multiline?: boolean
    onChange: (e: ChangeEvent<HTMLInputElement>) => void
}

const ToggleEditTextFieldMultiline: FC<ToggleEditTextFieldMultilineProps> = ({
    edit,
    label,
    onChange,
    value,
    disabled,
    multiline,
}) => {
    if (edit)
        return (
            <TextField
                label={label}
                value={value}
                onChange={onChange}
                fullWidth
                disabled={disabled}
                multiline={multiline}
                minRows={3}
                maxRows={7}
                InputLabelProps={{ shrink: true }}
            />
        )

    return (
        <>
            <InputLabel sx={{ fontSize: fontSize.xsmall }}>{label}</InputLabel>
            <Box style={{ height: '10vh', overflowY: 'auto' }}>
                <div>{value || '-'}</div>
            </Box>
        </>
    )
}

export default ToggleEditTextFieldMultiline
